import { Card, Flex } from '@mantine/core'
import {
  RiArrowRightLine,
  RiHeadphoneLine,
  RiPhoneLine,
} from '@remixicon/react'
import { useTranslations } from 'next-intl'

export const HelpOptions = () => {
  const t = useTranslations('Ui.customer-support')
  return (
    <Flex gap='sm'>
      <Card
        flex={1}
        radius='lg'
        className='flex flex-col items-start'
        p='sm'
        my='lg'
        bg='var(--mantine-color-Neutral-2)'
        withBorder
        style={{ borderColor: 'var(--mantine-color-Neutral-3)' }}
      >
        <Flex gap='xs' direction='column'>
          <div className='bg-[var(--color-background-gray)] p-4 rounded-full self-start'>
            <RiPhoneLine size={20} />
          </div>
          <div className='inline-flex items-center space-x-1 text-sm font-semibold mt-2 gap-2'>
            <span>{'Call us anytime'}</span>
            <RiArrowRightLine size={18} />
          </div>
        </Flex>
      </Card>
      <Card
        flex={1}
        radius='lg'
        className='flex flex-col items-start'
        p='sm'
        my='lg'
        bg='var(--mantine-color-Neutral-2)'
        withBorder
        style={{ borderColor: 'var(--mantine-color-Neutral-3)' }}
      >
        <Flex gap='xs' direction='column'>
          <div className='bg-[var(--color-background-gray)] p-4 rounded-full self-start'>
            <RiHeadphoneLine size={20} />
          </div>
          <div className='inline-flex items-center space-x-1 text-sm font-semibold mt-2 gap-2'>
            <span>{t('title')}</span>
            <RiArrowRightLine size={18} />
          </div>
        </Flex>
      </Card>
    </Flex>
  )
}
